import { useMemo } from 'react';
import { useTrackedPageContext } from 'src/context/trackedPage';
import {
  AnalyticsDataEvent,
  AnalyticsDataProperty,
  AnalyticsEventPhrasebookPhraseSelected,
} from 'src/types/googleAnalyticsEvents';
import { SearchData } from './useEventPhrasebookPageSearch';

type PhraseData = {
  learnableTargetValue: string;
  currentPage: number;
};

export function useEventPhrasebookPhraseSelected(
  { learnableTargetValue, currentPage }: PhraseData,
  { query, resultsLength }: SearchData,
): AnalyticsEventPhrasebookPhraseSelected {
  const trackedPageContext = useTrackedPageContext();

  return useMemo(
    () => ({
      [AnalyticsDataProperty.event]: AnalyticsDataEvent.phrasebookPhraseSelected,
      [AnalyticsDataProperty.phraseSelected]: learnableTargetValue,
      [AnalyticsDataProperty.phrasebookPageNumber]: currentPage,
      [AnalyticsDataProperty.searchQuery]: query,
      [AnalyticsDataProperty.searchResults]: resultsLength,
      ...trackedPageContext,
    }),
    [learnableTargetValue, currentPage, query, resultsLength, trackedPageContext],
  );
}
